import { resizeMediaByWidth } from '@wix/wixstores-client-core/dist/es/src/media/mediaService';
export var getMediaDimensions = function (product, defaultDimensions) {
    var primaryMedia = product.media[0];
    if (primaryMedia) {
        return resizeMediaByWidth(primaryMedia, 100);
    }
    return defaultDimensions;
};
//# sourceMappingURL=itemUtilsWithSideEffect.js.map